export default [
  {
    path: '/organization',
    name: 'organization',
    component: () => import('@/views/captain/organization/Organization.vue'),
    meta: {
      organizationAccess: true,
      globalAccess: true,
      noOrganizationAccess: true,
    },
  },
  {
    path: '/organization/add',
    name: 'organization-add',
    component: () => import('@/views/captain/organization/add/Add.vue'),
    meta: {
      organizationAccess: true,
      globalAccess: true,
      noOrganizationAccess: true,
    },
  },
  {
    path: '/organization/:organizationId/:projectId?/settings',
    name: 'organization-settings',
    component: () => import('@/views/captain/organization/Settings.vue'),
    meta: {
      organizationRequired: true,
      pageTitle: 'Organization',
      breadcrumb: [
        { text: 'Captain', disabled: true },
        { text: 'Organization Settings', active: true },
      ],
      organizationAccess: true,
      globalAccess: true,
    },
  },
  {
    path: '/organization/:organizationId/:projectId?/edit',
    name: 'organization-edit',
    component: () => import('@/views/captain/organization/general/Edit.vue'),
    meta: {
      organizationRequired: true,
      pageTitle: 'Organization',
      breadcrumb: [
        { text: 'Captain', disabled: true },
        {
          text: 'Organization Settings',
          to: { name: 'organization-settings', query: { tab: '0' } },
        },
        { text: 'Edit Organization', active: true },
      ],
      organizationAccess: true,
      globalAccess: true,
    },
  },
  {
    path: '/organization/:organizationId?/:projectId?/new-user',
    name: 'add-organization-user',
    component: () => import('@/views/captain/organization/users/Add.vue'),
    meta: {
      organizationRequired: true,
      pageTitle: 'Organization',
      breadcrumb: [
        { text: 'Captain', disabled: true },
        {
          text: 'Organization Settings',
          to: { name: 'organization-settings', query: { tab: '1' } },
        },
        { text: 'Invite new user', active: true },
      ],
      organizationAccess: true,
      globalAccess: true,
    },
  },
  {
    path: '/organization/:organizationId?/:projectId?/user/:id',
    name: 'edit-organization-user',
    component: () => import('@/views/captain/organization/users/Edit.vue'),
    meta: {
      organizationRequired: true,
      pageTitle: 'Organization',
      breadcrumb: [
        { text: 'Captain', disabled: true },
        {
          text: 'Organization Settings',
          to: { name: 'organization-settings', query: { tab: '1' } },
        },
        { text: 'Edit user', active: true },
      ],
      organizationAccess: true,
      globalAccess: true,
    },
  },
  {
    path: '/:organizationId/project',
    name: 'project',
    component: () => import('@/views/captain/project/Project.vue'),
    meta: {
      organizationRequired: true,
      globalAccess: true,
    },
  },
  {
    path: '/:organizationId/project/add',
    name: 'project-add',
    component: () => import('@/views/captain/project/Add.vue'),
    meta: {
      organizationRequired: true,
    },
  },
  {
    path: '/project/:projectId/edit',
    name: 'project-edit',
    component: () => import('@/views/captain/project/general/Edit.vue'),
    meta: {
      projectRequired: true,
      pageTitle: 'Project',
      breadcrumb: [
        { text: 'Captain', disabled: true },
        {
          text: 'Project Settings',
          to: { name: 'project-settings', query: { tab: 0 } },
        },
        { text: 'Edit Project', active: true },
      ],
    },
  },
  {
    path: '/project/:projectId/settings',
    name: 'project-settings',
    component: () => import('@/views/captain/project/Settings.vue'),
    meta: {
      projectRequired: true,
      pageTitle: 'Project',
      breadcrumb: [
        { text: 'Captain', disabled: true },
        { text: 'Project Settings', active: true },
      ],
    },
  },
  {
    path: '/project/:projectId/new-user',
    name: 'add-project-user',
    component: () => import('@/views/captain/project/users/Add.vue'),
    meta: {
      projectRequired: true,
      pageTitle: 'Project',
      breadcrumb: [
        { text: 'Captain', disabled: true },
        {
          text: 'Project Settings',
          to: { name: 'project-settings', query: { tab: 1 } },
        },
        { text: 'Invite new user', active: true },
      ],
    },
  },
  {
    path: '/project/:projectId/user/:id',
    name: 'edit-project-user',
    component: () => import('@/views/captain/project/users/Edit.vue'),
    meta: {
      projectRequired: true,
      pageTitle: 'Project',
      breadcrumb: [
        { text: 'Captain', disabled: true },
        {
          text: 'Project Settings',
          to: { name: 'project-settings', query: { tab: 1 } },
        },
        { text: 'Edit user', active: true },
      ],
    },
  },
  {
    path: '/organization/:organizationId?/:projectId?/create-role',
    name: 'create-role',
    component: () => import('@/views/captain/organization/roles/Add.vue'),
    meta: {
      organizationRequired: true,
      pageTitle: 'Organization',
      breadcrumb: [
        { text: 'Captain', disabled: true },
        {
          text: 'Organization Settings',
          to: { name: 'organization-settings', query: { tab: '2' } },
        },
        { text: 'Create new Role', active: true },
      ],
      organizationAccess: true,
    },
  },
  {
    path: '/organization/:organizationId?/:projectId?/edit-role/:id',
    name: 'edit-role',
    component: () => import('@/views/captain/organization/roles/Edit.vue'),
    meta: {
      organizationRequired: true,
      pageTitle: 'Organization',
      breadcrumb: [
        { text: 'Captain', disabled: true },
        {
          text: 'Organization Settings',
          to: { name: 'organization-settings', query: { tab: '2' } },
        },
        { text: 'Edit role', active: true },
      ],
      organizationAccess: true,
    },
  },
  {
    path: '/:organizationId/:projectId?/billing',
    component: () => import('@/views/captain/billing/Billing.vue'),
    children: [
      {
        path: 'overview',
        name: 'billing',
        component: () => import('@/views/captain/billing/Overview.vue'),
        meta: {
          organizationRequired: true,
          pageTitle: 'Billing',
          breadcrumb: [
            { text: 'Captain', disabled: true },
            { text: 'Overview', active: true },
          ],
          organizationAccess: true,
          noAnimation: true,
        },
      },
      {
        path: 'invoices',
        name: 'billing-invoices',
        component: () => import('@/views/captain/billing/invoices/Invoices.vue'),
        meta: {
          organizationRequired: true,
          pageTitle: 'Billing',
          breadcrumb: [
            { text: 'Captain', disabled: true },
            { text: 'Invoices', active: true },
          ],
          organizationAccess: true,
          noAnimation: true,
        },
      },
      {
        path: 'payments',
        name: 'payments',
        component: () => import('@/views/captain/billing/payments/Payments.vue'),
        meta: {
          organizationRequired: true,
          pageTitle: 'Billing',
          breadcrumb: [
            { text: 'Captain', disabled: true },
            { text: 'Payments', active: true },
          ],
          organizationAccess: true,
          noAnimation: true,
        },
      },
    ],
  },
  {
    path: '/:organizationId/:projectId?/payment-details/:id',
    name: 'payment-details',
    component: () => import('@/views/captain/billing/payments/Details.vue'),
    meta: {
      organizationRequired: true,
      pageTitle: 'Payment Details',
      breadcrumb: [
        { text: 'Captain', disabled: true },
        { text: 'Payments', to: { name: 'payments' } },
        { text: 'Payment Details', active: true },
      ],
      organizationAccess: true,
      noAnimation: true,
    },
  },
  {
    path: '/:organizationId/:projectId?/invoices-details/:id',
    name: 'invoice-details',
    component: () => import('@/views/captain/billing/invoices/Details.vue'),
    meta: {
      organizationRequired: true,
      pageTitle: 'Invoice Details',
      breadcrumb: [
        { text: 'Captain', disabled: true },
        { text: 'Invoices', to: { name: 'billing-invoices' } },
        { text: 'Invoice Details', active: true },
      ],
      organizationAccess: true,
      noAnimation: true,
    },
  },
  {
    path: '/:organizationId/edit-billing/',
    name: 'edit-billing',
    component: () => import('@/views/captain/billing/Edit.vue'),
    meta: {
      pageTitle: 'Organization',
      breadcrumb: [
        { text: 'Captain', disabled: true },
        { text: 'Edit Billing', active: true },
      ],
      organizationAccess: true,
    },
  },
]
